import { apiClientMainV2 } from "../../../lib/client-api";
import { Mapper } from "../../../lib/utils/mapper";
import { mapAiChatbotCmsPrompts } from "../../../features/ai-chatbot/utils/map-ai-chatbot-cms-prompt";
import type { AiChatbotCmsPrompt } from "../../../features/ai-chatbot/types/ai-chatbot-cms-prompt.entity";
import { AiChatbotCmsPromptDto } from "./dto/ai-chatbot-cms-prompt.dto";
import type { IAiChatbotCmsPromptDto } from "./dto/ai-chatbot-cms-prompt.dto.interface";

const IN_CHAT_PROMPTS_ENDPOINT = "/ai-prompt-configurations/chat";
const IN_PAGE_PROMPTS_ENDPOINT = "/ai-prompt-configurations/page";

export async function getActiveInChatPrompts(): Promise<AiChatbotCmsPrompt[]> {
  const response = await apiClientMainV2.get<IAiChatbotCmsPromptDto[]>(IN_CHAT_PROMPTS_ENDPOINT);
  const dtos = Mapper.mapArrayData(AiChatbotCmsPromptDto, response.data);
  return mapAiChatbotCmsPrompts(dtos);
}

export async function getActiveInPagePrompts(): Promise<AiChatbotCmsPrompt[]> {
  const response = await apiClientMainV2.get<IAiChatbotCmsPromptDto[]>(IN_PAGE_PROMPTS_ENDPOINT);
  const dtos = Mapper.mapArrayData(AiChatbotCmsPromptDto, response.data);
  return mapAiChatbotCmsPrompts(dtos);
}
